export default {
  methods: {
    copy (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$notify.info({
          message: 'کپی انجام شد',
          position: 'topCenter',
          transitionIn: 'fadeInDown',
          transitionOut: 'fadeOutUp'
        })
      }).catch((e) => {
        this.$notify.info({
          message: this.$t('copy_in_clipboard_error')
        })
        this.$logger.captureException({ error: e })
      })
    }
  }
}
